var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoalChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.304 1.01562C6.79036 1.37999 0 8.39739 0 17.0008C0 25.8373 7.16344 33.0008 16 33.0008C24.1295 33.0008 30.8429 26.9379 31.8652 19.0871H30.8561C29.8407 26.3838 23.5763 32.0008 16 32.0008C7.71573 32.0008 1 25.285 1 17.0008C1 8.94976 7.34285 2.38021 15.304 2.01662V1.01562Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8041 1L15.8041 18.7371",
    stroke: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.865 19.1953L15.3043 19.1953",
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V1C29.6 2.24444 32 10.8519 32 15H20Z",
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalChart);
export default __webpack_public_path__ + "static/media/goal_chart.e7f6ac8d9d5b353ec4e350c6ae205978.svg";
export { ForwardRef as ReactComponent };